import ErrorFullScreenMessage from "../../../components/fullScreenMessage/ErrorFullScreenMessage";
import Loader from "../../../components/loader/Loader";
import * as key from "../../../enums/QueryKeys";
import useUser from "../../../hooks/useUser";
import * as api from "../../../enums/ApiPaths";
import { useFetch } from "../../../hooks/Fetching";

export default function useAboutUs() {
  const { currentClinic } = useUser();
  const url = api.ABOUT_US;
  const enableFetching =  currentClinic?.id != null;
  const { data, isLoading, error } = useFetch(
    url,
    currentClinic?.id,
    key.ABOUT_US,
    enableFetching
  );

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return <ErrorFullScreenMessage />;
  }
  return data;
}
